import React, { useState, useMemo, useEffect, useRef } from "react";
import { Wrapper } from "./index.styled";
import QuickFilters from "../QuickFilters";
import Dropdown from "../Dropdown";
import FilterComp from "../FilterComp";
import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { useFilters } from "../../hooks/useFilters";

const TopbarFilters = ({
  title = "Title",
  subTitle = "SubTitle",
  list,
  filtersData,
  onFilterConfigSave,
  filteredData,
  setFilteredData,
  selectedOption,
  setSelectedOption,
}) => {
  const { quickFilter, toggleQuickFilter } = useFilters();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isAdvancedFilterVisible, setIsAdvancedFilterVisible] = useState(false);

  const [isEditing, setIsEditing] = useState(false); // Add state for tracking edit mode

  const [filters, setFilters] = useState(filtersData);
  const [pendingChanges, setPendingChanges] = useState(null);
  const [customFilterFlag, setCustomFilterFlag] = useState(false);
  const [isShowFilters, setIsShowFilters] = useState(false);
  const [isSaveAndApply, setIsSaveAndApply] = useState(false);
  const [editSavedSearch, setEditSavedSearch] = useState(null);
  // useEffect(() => {
  //   if (quickFilter !== null) {
  //     dispatch(setQuickFilter(null));
  //   }
  // }, [globalFilter, dispatch]);

  useEffect(() => {
    // Update filters only when another filter (like "State") changes filtersData
    setFilters((prevFilters) =>
      prevFilters.map((filter) => ({
        ...filter,
        count: filtersData.find((f) => f.id === filter.id)?.count,
      })),
    );
  }, [filtersData]);

  // const handleEditClick = () => {
  //   if (isEditing && pendingChanges) {
  //     // Save changes when clicking the tick
  //     setFilters(pendingChanges);
  //     setPendingChanges(null);

  //     // Notify parent of new configuration
  //     onFilterConfigSave?.(pendingChanges);
  //   }

  //   dispatch(setQuickFilter(null));

  //   setIsEditing(!isEditing);
  // };

  const defaultFilters = filters.filter((filter) => filter.default);
  const nonDefaultOptions = useMemo(
    () =>
      filters
        .filter((filter) => !filter.default)
        .map((filter) => ({
          value: filter.id,
          label: filter.title,
        })),
    [filters],
  );
  const handleFilterChange = (oldFilterId, selectedOption) => {
    setFilters((prevFilters) => {
      // Create a copy of the filters array
      const updatedFilters = [...prevFilters];
      // Find the filter to be replaced (old filter)
      const oldFilterIndex = updatedFilters.findIndex(
        (f) => f.id === oldFilterId,
      );

      // Find the selected filter (new filter)
      const newFilter = updatedFilters.find(
        (f) => f.id === selectedOption.value,
      );

      if (oldFilterIndex === -1 || !newFilter) return prevFilters;

      // Create the swapped filters
      const oldFilter = {
        ...updatedFilters[oldFilterIndex],
        default: false, // Make old filter non-default
      };

      const swappedNewFilter = {
        ...newFilter,
        default: true, // Make new filter default
      };

      // Remove both filters from their current positions
      const filteredArray = updatedFilters.filter(
        (f) => f.id !== oldFilterId && f.id !== selectedOption.value,
      );

      // Insert new filter at the old position and old filter at the end
      filteredArray.splice(oldFilterIndex, 0, swappedNewFilter);
      filteredArray.push(oldFilter);
      return filteredArray;
    });
  };

  const handleQuickFilter = (filterId) => {
    toggleQuickFilter(filterId);
  };
  const handleCustomSearchEditClick = (option) => {
    setIsPopupVisible(true);
    setIsAdvancedFilterVisible(true);
    setIsSaveAndApply(true);
    setEditSavedSearch(option);
    setFilteredData(option.value.filteredData);
  };

  return (
    <Wrapper>
      <FilterComp
        filteredData={filteredData}
        setFilteredData={setFilteredData}
        customFilterFlag={customFilterFlag}
        setCustomFilterFlag={setCustomFilterFlag}
        isPopupVisible={isPopupVisible}
        setIsPopupVisible={setIsPopupVisible}
        isAdvancedFilterVisible={isAdvancedFilterVisible}
        setIsAdvancedFilterVisible={setIsAdvancedFilterVisible}
        isSaveAndApply={isSaveAndApply}
        setIsSaveAndApply={setIsSaveAndApply}
        editSavedSearch={editSavedSearch}
      />
      <Dropdown
        filteredData={filteredData}
        setFilteredData={setFilteredData}
        customFilterFlag={customFilterFlag}
        setCustomFilterFlag={setCustomFilterFlag}
        onEditClick={handleCustomSearchEditClick}
        setSelectedOption={setSelectedOption}
        selectedOption={selectedOption}
      />
      <Container>
        {defaultFilters.map((filter) => (
          <QuickFilters
            key={filter.id}
            filterId={filter.id}
            title={filter.title}
            subTitle={filter.count}
            list={list}
            showFilters={isEditing}
            right={filter.id === "rural"} // Add right prop for rural filter
            options={nonDefaultOptions}
            onFilterChange={handleFilterChange}
            onClick={handleQuickFilter}
            color={"#E35B42"}
            isSelected={quickFilter === filter.id}
          />
        ))}
        {/* <EditButton onClick={handleEditClick}>
          {isEditing ? <TickIcon /> : <EditIcon />}
        </EditButton> */}
      </Container>
    </Wrapper>
  );
};

export default TopbarFilters;

const Container = styled.div`
  /* width: ${() => `${viewSizeCalculator(59.25)}`}; */
  display: flex;
  flex: 1;
  align-items: center;
  /* border:1px solid black; */
  gap: ${() => `${viewSizeCalculator(0.75)}`};
`;

const EditButton = styled.div`
  width: ${() => `${viewSizeCalculator(4)}`};
  height: ${() => `${viewSizeCalculator(4)}`};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 0.0625rem 0.3125rem #3333331a;
  padding: ${() =>
    `${viewSizeCalculator(0.625)} ${viewSizeCalculator(
      0.75,
    )} ${viewSizeCalculator(0.625)} ${viewSizeCalculator(0.75)}`};
`;
